import React, { Component } from 'react';

import _ from 'lodash';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { Actions } from '../../../../../actions';
import { Edit } from '../../../../common/icons';
import { Buttonize } from '../campaignTree/Common';

const BulkEditButtonContainer = styled(Buttonize).withConfig({
  displayName: 'BulkEditButtonContainer',
})`
  width: 32px;
  height: 35px;
  border-color: rgb(216, 216, 216) rgb(209, 209, 209) rgb(186, 186, 186);
  border: var(--input-border);
  border-radius: 0.2rem;
  padding: 6px;
  margin-right: 3px;
  flex-shrink: 0;
  flex-grow: 0;
`;

type internalPropsT = { config: columnsConfigT, selectAction: WorkerAc };
type internalActionsT = { onSelect: Function };
type internalStateT = { config: columnsConfigT };
const defaultState: internalStateT = {
  config: {},
};

class AbstractBulkEditRedirects extends Component<internalPropsT | internalActionsT, internalStateT> {
  state = defaultState;

  render() {
    const { showBulkEdit } = this.props;

    return (
      <>
        <BulkEditButtonContainer>
          <Edit onClick={showBulkEdit} />
        </BulkEditButtonContainer>
      </>
    );
  }
}

// noinspection JSUnusedLocalSymbols
const stateToProps = (state: stateT) => ({
  config: state.front.bulkEditRedirectsModalConfig,
});

// noinspection JSUnusedGlobalSymbols
const dispatchToProps = (dispatch: Dispatch<*>, ownProps: Object) => ({
  showBulkEdit: (_) => {
    dispatch(Actions.front.audienceBuilder.redirect.bulkEdit.show.request({}));
  },
});

// noinspection JSUnusedLocalSymbols
const areStatesEqual = (prev: stateT, next: stateT) =>
  _.isEqual(prev.front.bulkEditRedirectsModalConfig, next.front.bulkEditRedirectsModalConfig);

const reduxWrapper = connect(stateToProps, dispatchToProps, null, {
  areStatesEqual,
});

export const BulkEditRedirects = reduxWrapper(AbstractBulkEditRedirects);
